import { render, staticRenderFns } from "./backgroundAccount.vue?vue&type=template&id=5ef4d070"
import script from "./backgroundAccount.vue?vue&type=script&lang=js"
export * from "./backgroundAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports